// extracted by mini-css-extract-plugin
export default {"inputs-container":"PromptSettings_inputs-container__M96yu","text-area-wrapper":"PromptSettings_text-area-wrapper__cNNv7","text-area":"PromptSettings_text-area__6W4Mu"};